import type { Fields } from 'types/builder/interface';

export const getVariationTitle = (variationsField: Fields['variationsField']) => {
    if (variationsField) {
        return variationsField[0][0].title;
    }

    return '';
};
